<template>
  <div v-if="isActive">
    <v-bottom-navigation
      v-model="selectedTab"
      fixed
      grow
      color="#48B38B"
      shift
      :style="isIphone() ? 'z-index: 100; padding-bottom: 20px !important; height: 76px;' : 'z-index: 100'"
    >
      <v-btn @click="changeTab(0)">
        <span>Serviços</span>
        <v-icon>mdi-car-multiple</v-icon>
      </v-btn>

      <v-btn @click="changeTab(1)">
        <span>Orçamentos</span>
        <v-icon>mdi-file-sign</v-icon>
      </v-btn>

      <v-btn class="new-action" @click="handleChangeTab(2)">
        <img :src="require('@/assets/icons/WhiteIcon.svg')" height="40" />
      </v-btn>

      <v-btn @click="changeTab(3)">
        <span>Agenda</span>
        <v-icon>mdi-calendar-clock</v-icon>
      </v-btn>

      <v-btn @click="changeTab(4)">
        <span>Config.</span>
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>
<script>
export default {
  name: 'AdvancedBottomNavigation',
  emits: ['update:tab'],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedTab: 0,
      user: null,
    };
  },
  mounted() {
    this.user = this.$store.getters['Auth/user'];
  },
  methods: {
    isIphone() {
      if (this.getOS() === 'iOS') {
        return true;
      }
      return !!(this.$route.query.t && this.$route.query.t === 'ios');
    },
    getOS() {
      const uA = navigator.userAgent || navigator.vendor || window.opera;
      if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
      return null;
    },
    changeTab(tabIndex) {
      this.selectedTab = tabIndex;
      this.$emit('update:tab', tabIndex);
    },
    handleChangeTab(tabIndex) {
      this.$emit('update:tab', tabIndex);
    },
  },
};
</script>
